// Analytics utility for AnyVolt website
// Using Google Analytics 4

const initializeAnalytics = () => {
  // This would normally be implemented with the Google Analytics gtag script
  // For now, we'll create a mock implementation if gtag is not available
  if (typeof window !== 'undefined') {
    // Initialize GA4 if the script is loaded
    if (typeof window.gtag === 'undefined') {
      // Mock gtag implementation for local development
      window.dataLayer = window.dataLayer || [];
      window.gtag = function() {
        // Log to console in development to simulate analytics
        if (process.env.NODE_ENV === 'development') {
          console.log('Analytics event:', arguments);
        }
      };
    }

    // Configure GA4 with the property ID (would be in environment variables)
    if (typeof window.gtag !== 'undefined') {
      window.gtag('js', new Date());
      window.gtag('config', process.env.REACT_APP_GOOGLE_ANALYTICS_ID || 'GA_MEASUREMENT_ID');
    }
  }
};

const trackPageView = (pagePath, pageTitle) => {
  if (typeof window !== 'undefined' && typeof window.gtag !== 'undefined') {
    window.gtag('event', 'page_view', {
      page_title: pageTitle,
      page_location: window.location.href,
      page_path: pagePath,
    });
  }
};

const trackEvent = (eventName, eventParams) => {
  if (typeof window !== 'undefined' && typeof window.gtag !== 'undefined') {
    window.gtag('event', eventName, eventParams);
  }
};

const trackDownloadClick = (platform) => {
  trackEvent('download_click', {
    platform: platform,
    source: 'website'
  });
};

const trackTrialSignup = (serviceType) => {
  trackEvent('trial_signup', {
    service_type: serviceType
  });
};

const trackFormSubmission = (formType) => {
  trackEvent('form_submission', {
    form_type: formType
  });
};

export {
  initializeAnalytics,
  trackPageView,
  trackEvent,
  trackDownloadClick,
  trackTrialSignup,
  trackFormSubmission
};